import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import ServerPricing from '../../homepage/header-banner/ServerPricing';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
// import '../../container/Sidebar/sidebar.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import CardBoxRow from '../../container/Box/Components/CardBox-Row'
// import { MuiGrid } from '@mui/material';
import CommonTable from '../../container/Table/Components/CommonTable';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import Cloudconsult2VN from '../../homepage/consult/cloudconsult-2-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';
const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;


// Titlecloudcompute
function EnterpriseVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Dạng doanh nghiệp - Private Kubernetes - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("엔터프라이즈형")} */}
                        {/* {Contentcloudcard("고성능 Local SSD replication Volume 적용 안정적인 서비스운영","모든 인스턴스에 물리적인 rCPU (1배수) 적용, 고용량의 메모리제공")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12} className='MuiGrid-card'>{CardBoxRow(
                                "<p class='typo-21-sm typo-medium typo-black'>Cấu hình Cluster Kubernetes doanh nghiệp riêng tư</p>",

                                `
                                <p class='typo-14'>Cụm Kubernetes doanh nghiệp riêng tư được triển khai toàn bộ trên hạ tầng BareMetal, tích hợp đầy đủ các node Master, Worker, cùng hệ thống lưu trữ Block Storage và Object Storage chuyên biệt.</p>
                                <p class='typo-14'>Cấu hình tiêu chuẩn bắt đầu với 13 máy chủ vật lý: tối thiểu 5 máy cho cluster Kubernetes, 5 máy cho Ceph Block Storage, và 4 máy cho hệ thống Object Storage (MinIO).</p>
                                
                                <p class='typo-14'>&nbsp;</p>
                                <ul>
                                    <li><p class="typo-14">Hạ tầng quy mô lớn: Triển khai trên 13 máy BareMetal, tối ưu cho doanh nghiệp cần độ ổn định và hiệu suất cao.</p></li>
                                    <li><p class="typo-14">Tích hợp lưu trữ phân tán: Kết hợp Ceph cho Block Storage và MinIO cho Object Storage (chuẩn S3), đảm bảo tính mở rộng và độ sẵn sàng cao.</p></li>
                                    <li><p class="typo-14">Đáp ứng các workload phức tạp: Phù hợp cho hệ thống microservices, xử lý dữ liệu lớn (big data), và các ứng dụng học máy (machine learning).</p></li>
                                    <li><p class="typo-14">Độ ổn định & khả năng mở rộng: Thiết kế hướng đến hiệu năng cao, đáp ứng yêu cầu vận hành liên tục của các hệ thống doanh nghiệp và trung tâm dữ liệu.</p></li>
                                    <li><p class="typo-14">Giải pháp hoàn chỉnh cho doanh nghiệp: Lý tưởng cho các tổ chức cung cấp dịch vụ quy mô lớn, cần môi trường hạ tầng riêng tư, bảo mật và mạnh mẽ.</p></li>
                                </ul>
                                `)}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} className='MuiGrid-card'>{Imagecloudcompute("https://hanbiro.com/assets/images/cloud/en/enterprise-structure.png")}</MuiGrid>
                            <DividerComponent />
                        </MuiGrid>
                        <Cloudconsult2VN />
                    </Col>
                </Row>
            </Container>

            <FooterVn />
        </Sysfont>
    );
};

const MuiGrid = styled.div`
    padding: 0px,
`

export default EnterpriseVN;